import {get} from './http'

/**
 * 视频开始上传 videoId == null
 */
export const uploadStart = (fileName) => get('https://apis.study.laodao.so/tool/vod/upload?filename=' + fileName, {
  coverurl: ''
})

/**
 * 视频开始上传刷新 videoId ！= null
 */
export const uploadRefStart = (videoId) => get('https://apis.study.laodao.so/tool/vod/upload/ref/' + videoId, {})
